import { render, staticRenderFns } from "./RevisionMultiselect.vue?vue&type=template&id=4ac609c6&"
import script from "./RevisionMultiselect.vue?vue&type=script&lang=js&"
export * from "./RevisionMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./RevisionMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports